exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".empty-tips[data-v-e33ff2e2]{text-align:center;padding:120px 0}.empty-tips>.text[data-v-e33ff2e2]{margin-top:15px;font-size:20px;color:#555}.empty-tips-tiny[data-v-e33ff2e2]{padding:10px 0}.empty-tips-tiny>.text[data-v-e33ff2e2]{font-size:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e33ff2e2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/common/empty.vue
// module id = 750
// module chunks = 23